export default __webpack_public_path__ + "static/media/minusPrimary.fe19de36.svg";